export const techData = [
  {
    tech_name: 'Angular',
    url: 'login',
    images: 'assets/images/landing/tech-angular.svg',
    target: true,
    tooltip: 'Angular',
    description:
      'Numeryx theme',
    freeRepo: true
  },
  {
    tech_name: 'React MUI',
    url: 'https://ableproadmin.com/react/dashboard/default',
    images: 'assets/images/landing/tech-react.svg',
    target: true,
    tooltip: 'React MUI',
    description:
      'Numeryx theme',
    freeRepo: true
  },
  {
    tech_name: 'Bootstrap 5',
    url: 'https://ableproadmin.com/dashboard/index.html',
    images: 'assets/images/landing/tech-bootstrap.svg',
    target: true,
    tooltip: 'Bootstrap 5',
    description:
      ' Numeryx theme',
    freeRepo: true
  },
  {
    tech_name: 'CodeIgniter',
    url: 'https://ableproadmin.com/codeigniter/default/public/dashboard-default',
    images: 'assets/images/landing/tech-codeigniter.svg',
    target: true,
    tooltip: 'CodeIgniter',
    description:
      'Numeryx theme',
    freeRepo: true
  },
  {
    tech_name: 'Next js',
    url: 'https://able-pro-material-next-ts-navy.vercel.app/dashboard/default',
    images: 'assets/images/landing/tech-nextjs.svg',
    target: true,
    tooltip: 'Next js',
    description:
      'Numeryx theme',
    freeRepo: true
  },
  {
    tech_name: 'Vue',
    url: 'https://ableproadmin.com/vue/dashboard/default',
    images: 'assets/images/landing/tech-vuetify.svg',
    target: true,
    tooltip: 'Vue',
    description:
      'Numeryx theme',
    freeRepo: true
  },
  {
    tech_name: 'Tailwind',
    url: 'https://ableproadmin.com/tailwind/dashboard/index.html',
    images: 'assets/images/landing/tech-tailwind.svg',
    target: true,
    tooltip: 'Tailwind',
    description:
      'Numeryx theme',
    freeRepo: true
  },
  {
    tech_name: 'Vue+Laravel',
    url: 'https://ableproadmin.com/vue-laravel/',
    images: 'assets/images/landing/tech-l+v.svg',
    target: true,
    tooltip: 'Vue+Laravel',
    description:
      'Numeryx theme',
    freeRepo: true
  },
  {
    tech_name: 'Django',
    url: 'javascript:',
    images: 'assets/images/landing/tech-django.svg',
    target: false,
    tooltip: 'Live Preview Is Not Available',
    description:
      'Numeryx theme',
    freeRepo: true
  },
  {
    tech_name: 'Flask',
    url: 'javascript:',
    images: 'assets/images/landing/tech-flask.svg',
    target: false,
    tooltip: 'Live Preview Is Not Available',
    description:
      'Numeryx theme',
    freeRepo: true
  },
  {
    tech_name: 'Laravel Bootstrap',
    url: 'javascript:',
    images: 'assets/images/landing/tech-laravel+bootstrap.svg',
    target: false,
    tooltip: 'Live Preview Is Not Available',
    description:
      'Numeryx theme',
    freeRepo: true
  },
  {
    tech_name: 'Node Js',
    url: 'javascript:',
    images: 'assets/images/landing/tech-nodejs.svg',
    target: false,
    tooltip: 'Live Preview Is Not Available',
    description:
      'Numeryx theme',
    freeRepo: true
  },
  {
    tech_name: 'Svelte Kit',
    url: 'javascript:',
    images: 'assets/images/landing/tech-svelteKit.svg',
    target: false,
    tooltip: 'Live Preview Is Not Available',
    description:
      'Numeryx theme',
    freeRepo: true
  }
];
